
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-book" })
export default class IconBook extends Vue {
  sData: string = require("@icon/feather/book.svg");
}
